export default __webpack_public_path__ + "static/media/guide_043.08b9a251.md";